const getVariantSkuForSelectedOptions = (
  selectedOptionsObject,
  optionsOrder
) => {
  if (!selectedOptionsObject) {
    return '';
  }

  return (
    optionsOrder?.reduce(
      (variantSkuAcc, optId) =>
        selectedOptionsObject[optId]?.sku
          ? variantSkuAcc + selectedOptionsObject[optId].sku
          : variantSkuAcc,
      ''
    ) ?? ''
  );
};

export default getVariantSkuForSelectedOptions;
